const TONE_CLASSES = {
  success: 'bg-success/16 hover:bg-success/24 border-success/60 text-success',
  warning: 'bg-warning/16 hover:bg-warning/24 border-warning/60 text-warning',
  error: 'bg-error/16 hover:bg-error/24 border-error/60 text-error',
  info: 'bg-info/16 hover:bg-info/24 border-info/60 text-info',
};

const TintedButton = ({
  tone = 'success',
  disabled = false,
  className = '',
  children,
  ...props
}) => {
  const toneClassName = disabled
    ? 'bg-surface-2 border-transparent text-content-muted cursor-not-allowed'
    : TONE_CLASSES[tone] || TONE_CLASSES.success;

  return (
    <button
      type="button"
      disabled={disabled}
      className={`px-6 py-3 rounded-lg font-medium flex items-center gap-2 border transition-colors ${toneClassName} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default TintedButton;
